import { Link, NavLink, useNavigate } from "react-router-dom";
import { Search, User, Heart, ShoppingBag, Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";

const nav = [
  { to: "/catalogo", label: "Catálogo" },
  { to: "/catalogo?category=Anéis", label: "Anéis" },
  { to: "/catalogo?category=Alianças", label: "Alianças" },
  { to: "/catalogo?category=Brincos", label: "Brincos" },
  { to: "/catalogo?category=Colares", label: "Colares" },
  { to: "/institucional", label: "Sobre" },
];

export default function Header() {
  const { user } = useAuth();
  const { count } = useCart();
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const close = () => setOpen(false);
    window.addEventListener("resize", close);
    return () => window.removeEventListener("resize", close);
  }, []);

  const submit = (e) => {
    e.preventDefault();
    if (q.trim()) navigate(`/catalogo?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <header
      className="sticky top-0 z-40 border-b border-[#C2A064]/20"
      style={{ backgroundColor: "rgba(248,245,239,0.85)", backdropFilter: "blur(16px)" }}
      data-testid="site-header"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between py-5 gap-6">
          <button
            className="md:hidden text-[#49392F]"
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>

          <Link to="/" className="flex-shrink-0" data-testid="logo-link">
            <div className="font-display text-2xl md:text-[28px] tracking-wide text-[#49392F] leading-none">
              Duo <span className="text-[#C2A064] italic">Áurea</span>
            </div>
            <div className="hidden md:block font-body text-[10px] tracking-[0.4em] text-[#49392F]/70 mt-1">
              JOIAS
            </div>
          </Link>

          <form onSubmit={submit} className="hidden md:flex flex-1 max-w-md items-center border border-[#E8DCCB] bg-white px-3">
            <Search size={16} className="text-[#49392F]/60" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Buscar joias, categorias, materiais..."
              className="flex-1 py-2.5 px-3 bg-transparent outline-none text-sm text-[#49392F] placeholder:text-[#49392F]/40"
              data-testid="header-search-input"
            />
          </form>

          <div className="flex items-center gap-5 text-[#49392F]">
            <Link to={user ? "/conta" : "/login"} className="hover:text-[#C2A064] transition-colors" data-testid="header-account-link" aria-label="Conta">
              <User size={20} />
            </Link>
            <Link to="/conta?tab=favoritos" className="hover:text-[#C2A064] transition-colors hidden sm:inline-flex" data-testid="header-favorites-link" aria-label="Favoritos">
              <Heart size={20} />
            </Link>
            <Link to="/carrinho" className="relative hover:text-[#C2A064] transition-colors" data-testid="header-cart-link" aria-label="Carrinho">
              <ShoppingBag size={20} />
              {count > 0 && (
                <span className="absolute -top-2 -right-2 bg-[#C2A064] text-white text-[10px] font-medium rounded-full w-4 h-4 flex items-center justify-center" data-testid="cart-count">
                  {count}
                </span>
              )}
            </Link>
          </div>
        </div>

        <nav className="hidden md:flex items-center justify-center gap-10 pb-4">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              className="link-elegant text-[11px] tracking-[0.25em] uppercase text-[#49392F] hover:text-[#49392F]"
              data-testid={`nav-${n.label.toLowerCase()}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        {open && (
          <div className="md:hidden pb-6 space-y-3" data-testid="mobile-menu">
            <form onSubmit={submit} className="flex items-center border border-[#E8DCCB] bg-white px-3 mb-4">
              <Search size={16} className="text-[#49392F]/60" />
              <input
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Buscar..."
                className="flex-1 py-2.5 px-3 bg-transparent outline-none text-sm"
              />
            </form>
            {nav.map((n) => (
              <NavLink key={n.to} to={n.to} onClick={() => setOpen(false)} className="block py-2 text-sm tracking-[0.2em] uppercase text-[#49392F]">
                {n.label}
              </NavLink>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}
